exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app[data-v-7ba5bd90] {\n  background-color: #EDF4F7;\n  width: 100vw;\n  overflow-x: hidden;\n}", ""]);

// exports
